import { useEffect, useState } from 'react';
import { SearchBox } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/SearchBox';
import { navigateTo } from 'renderer/utils/navigate';
import { useSearchParams } from 'renderer/hooks/useSearchParams';
import { RECIPE_QUERY_SEARCH_TERM, RECIPE_SEARCH_ID, RECIPE_SEARCH_PATH } from '../constants';

const RecipeSearchBar = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [inputValue, setInputValue] = useState('');

  const searchTerm = searchParams.get(RECIPE_QUERY_SEARCH_TERM) ?? '';

  useEffect(() => {
    setInputValue(searchTerm);
  }, [searchTerm]);

  const handleSubmit = () => {
    if (window.location.pathname === RECIPE_SEARCH_PATH) {
      setSearchParams({ [RECIPE_QUERY_SEARCH_TERM]: inputValue });
    } else {
      navigateTo(
        `${RECIPE_SEARCH_PATH}?${RECIPE_QUERY_SEARCH_TERM}=${encodeURIComponent(inputValue)}`,
      );
    }
  };

  return (
    <SearchBox
      ariaTitle="Recipes"
      id={RECIPE_SEARCH_ID}
      value={inputValue}
      placeholder="Search by recipe or ingredient..."
      onChange={e => setInputValue(e.target.value)}
      onSubmit={handleSubmit}
      onClearClick={() => {
        setInputValue('');
        setSearchParams({ [RECIPE_QUERY_SEARCH_TERM]: '' });
      }}
    />
  );
};

export default RecipeSearchBar;
